import React, { useEffect } from "react";
import { Flex, Grid, GridItem, Box } from "@chakra-ui/react";
import FinancePieChart from "../components/FinancePieChart";
import DasboardCards from "../components/DasboardCards";
import { useDispatch, useSelector } from "react-redux";
import { fetchFinanceDashboard } from "../redux/slices/dashboardSlice";
import AdminDashboardExamReport from "../components/AdminDashboardExamReport";
import DashboardActivityBarChart from "../components/DashboardActivityBarCharts";
import FinanceDashboardBarChart from "../components/FinanceDashboardBarChart";

const FinanceDashboard = () => {
  const dispatch = useDispatch();
  const financeDashboardData = useSelector(
    (state) => state?.dashboard?.financeDashboard
  );

  useEffect(() => {
    dispatch(fetchFinanceDashboard());
  }, [dispatch]);

   const data = [
    {
      name: "Total Amount From Event Application",
      number: new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGN",
      }).format(   financeDashboardData?.eventApplicationAmount?.membersTotalAmount +
        financeDashboardData?.eventApplicationAmount?.nonMembersTotalAmount || 0)
     ,
      colors: ["#D11A2A", "#C4A5B9"],
      pieChartData: [
        {
          name: "Members",
          value:
            financeDashboardData?.eventApplicationAmount?.membersTotalAmount ||
            0,
        },
        {
          name: "Non-members ",
          value:
            financeDashboardData?.eventApplicationAmount?.nonMembersTotalAmount || 0,
        },
      ],
    }, 
    {
      name: "Total Amount From Exam Application",
      number:new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGN",
      }).format(  financeDashboardData?.examApplicationAmount?.[0]?.totalAmount || 0),
      colors: ["#023A59", "#3064FC", "#979797", "#EBE3EB"],
      pieChartData: (financeDashboardData?.examApplicationAmount || []).map(
        (item) => ({
          name: item.examStage,
          value: item?.totalAmount,
        })
      ),
    },    
    {
      name: "Total Amount From Member Application Payment",
      number: new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGN",
      }).format(financeDashboardData?.memberApplicationPayment?.totalAmountAll || 0),
      colors: ["#D11A2A", "#979797", "#FFC34F", "#3064FC"],
      pieChartData: [
        {
          name: "Student",
          value:
            financeDashboardData?.memberApplicationPayment?.totalAmountStudent,
        },
        {
          name: "NYSC",
          value:
            financeDashboardData?.memberApplicationPayment?.totalAmountNYSC,
        },
        {
          name: "Associate",
          value:
            financeDashboardData?.memberApplicationPayment?.totalAmountAssociate,
        },
        {
          name: "Graduate",
          value:
            financeDashboardData?.memberApplicationPayment?.totalAmountGraduate,
        },
      ],
    },
  ];

  const memberStats = financeDashboardData?.memberReport;

  const totalMembers = memberStats?.totalMembers || 0;
  const totalNonMembers = memberStats?.totalNonMembers || 0;
  const totalOldMembers = memberStats?.totalOldMembers || 0;

  const memberReportData = {
    title: "Member Report",
    color1: "#F86624",
    color2: "#22CAAD",
    color3: "#EB3D4D",
    text1: "Total Members",
    text2: "Total Non-Members",
    text3: "Total Old Members",
    value1: totalMembers.toLocaleString(),
    value2: totalNonMembers.toLocaleString(),
    value3: totalOldMembers.toLocaleString(),
  };

  return (
    <Flex
      flexDirection={"column"}
      gap={"20px"}
      py={"30px"}
      minH={"100vh"}
      px={3}
    >
      <Flex gap={5} flexDirection={["column", "column", "column", "row"]}>
        <Flex
          flexDirection={"column"}
          gap={"20px"}
          py={"30px"}
          px={3}
          w={["100%", "100%", "100%", "70%", "75%"]}
        >
          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(3, 1fr)",
            ]}
            gap={[5, 5, 5, 3]}
          >
            {data?.map((item, index) => (
              <GridItem key={index}>
                <DasboardCards
                  name={item?.name}
                  number={item?.number}
                  colors={item?.colors}
                  pieChartData={item?.pieChartData}
                  showLabels={false}
                />
              </GridItem>
            ))}
          </Grid>
          <FinanceDashboardBarChart
            financeDashboardData={financeDashboardData?.transactionStatusTotals}
          />
        </Flex>
        <Box mt={7} width={["100%", "100%", "100%", "30%", "25%"]}>
          <FinancePieChart
            financePieChartData={financeDashboardData?.memberCategoryCounts}
          />
        </Box>
      </Flex>
      <Flex flexDirection={'column'} gap={5} width={"100%"}>
      <DashboardActivityBarChart
        barChartData={financeDashboardData?.activityReports}
      />
      <Box w={'100%'}>

      <AdminDashboardExamReport {...memberReportData} />
      </Box>
      </Flex> 
    </Flex>
  );
};

export default FinanceDashboard;
